class LazyVideo extends HTMLElement {
  constructor() {
    super(); // must come first
  }

  connectedCallback() {
    this.video = this.querySelector('video');
    if (!this.video) return;

    this.video.setAttribute('playsinline', '');
    this.video.setAttribute('webkit-playsinline', '');

    this.observer = new IntersectionObserver(this.onEntry.bind(this), { threshold: 0 });
    this.observer.observe(this.video);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.observer = null;
  }

  onEntry([entry], observer) {
    if (!entry || !entry.isIntersecting) return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) {
      this.video.removeAttribute('autoplay');
      this.video.pause();
    }

    if (this.video.dataset?.poster) {
      this.video.setAttribute('poster', this.video.dataset.poster);
    }

    this.video.querySelectorAll('source[data-src]').forEach(s => { s.src = s.dataset.src; });
    this.video.load();

    observer.unobserve(this.video);
    this.setAttribute('loaded', '');

    // Skip autoplay on small screens or when autoplay not present
    const isSmall = window.matchMedia('(max-width: 767px)').matches;
    if (isSmall || this.video.hasAttribute('autoplay') === false) return;

    if (this.video.paused) {
      const onTouch = () => this.video.paused && this.video.play().catch(() => {});
      document.addEventListener('touchstart', onTouch, { once: true, passive: true });
    }
  }
}

if (!customElements.get('lazy-video')) {
  customElements.define('lazy-video', LazyVideo);
}
export default LazyVideo;
